import { GlobalState } from "domain/types";
import { REQUEST_STATUS } from "lib/types";
import { createSelector } from "reselect";

export const getCoreState = (state: GlobalState) => state.core;

export const getValidateFetchStatus = createSelector(
  getCoreState,
  (state) => state.validateAddressRequestStatus,
);

export const getRateCardFetchStatus = createSelector(
  getCoreState,
  (state) => state.rateCardsRequestStatus,
);

export const getRateCard = createSelector(getCoreState, (state) =>
  state.rateCards?.find(
    (rateCard) =>
      rateCard.product_code === state.selectedProduct &&
      rateCard.usage_type === state.user.property.usageType,
  ),
);

export const getRateCards = createSelector(getCoreState, (state) =>
  state.rateCards ? state.rateCards : undefined,
);

export const getSelectedAddress = createSelector(
  getCoreState,
  (state) => state.selectedAddress,
);
export const getFlickAccountError = createSelector(
  getCoreState,
  (state) => state.flickAccountError,
);

export const getSelectedEligibilityType = createSelector(
  getCoreState,
  (state) => state.selectedEligibilityType,
);

export const getEligibleAddresses = createSelector(
  getCoreState,
  (state) => state.eligibleAddresses,
);

export const getVerificationId = createSelector(
  getCoreState,
  (state) => state.verifyId,
);

export const getVerificationFetchStatus = createSelector(
  getCoreState,
  (state) => state.verificationRequestStatus,
);

export const getVerifyCodeFetchStatus = createSelector(
  getCoreState,
  (state) => state.verifyCodeRequestStatus,
);

export const getCompleteRegistrationRequestStatus = createSelector(
  getCoreState,
  (state) => state.completeRegistrationRequestStatus,
);

export const getUpdateFlickSignUpRequestStatus = createSelector(
  getCoreState,
  (state) => state.updateFlickSignUpRequestStatus,
);

export const getFlickUserId = createSelector(
  getCoreState,
  (state) => state.flickUserId,
);
export const getTransactionId = createSelector(
  getCoreState,
  (state) => state.transactionId,
);

export const getCCAuthSuccessful = createSelector(
  getCoreState,
  (state) =>
    state.windcaveAuthorisationRequestStatus === REQUEST_STATUS.Fulfilled,
);

export const getSignUpState = createSelector(
  getCoreState,
  (state) => state.signUpState,
);

export const getCurrentFormStep = createSelector(
  getCoreState,
  (state) => state.currentFormStep,
);

export const getPartialSignUpDialogState = createSelector(
  getCoreState,
  (state) => state.partialSignUpDialogOpen,
);

export const getPromoCode = createSelector(
  getCoreState,
  (state) => state.promoCode,
);

export const getLeadSource = createSelector(
  getCoreState,
  (state) => state.leadSource,
);

export const getSelectedProduct = createSelector(
  getCoreState,
  (state) => state.selectedProduct,
);

export const getEvChargerInclusion = createSelector(
  getCoreState,
  (state) => state.productMetadata.includeEVcharger,
);

export const getSelectedEvChargerColor = createSelector(
  getCoreState,
  (state) => state.productMetadata.evChargerColor,
);

export const getProductMetadata = createSelector(
  getCoreState,
  (state) => state.productMetadata,
);

export const getUsageType = createSelector(
  getCoreState,
  (state) => state.user.property.usageType,
);

export const getUser = createSelector(getCoreState, (state) => state.user);
export const getUserDetails = createSelector(getUser, (user) => user.details);
export const getUserPayment = createSelector(getUser, (user) => user.payment);
export const getUserProperty = createSelector(getUser, (user) => user.property);
export const getUserRewards = createSelector(getUser, (user) => user.rewards);

export const getUserVerifiedDetail = createSelector(
  getUserDetails,
  (details) => details.mobileNumber,
);

export const getSignupLitres = createSelector(getCoreState, (state) => {
  return state.campaigns[0]?.campaignLitres;
});

export const getCreationSource = createSelector(getCoreState, (state) => {
  return state.creationSource;
});
